document.addEventListener("DOMContentLoaded", function () {
  const parentDiv = document.querySelector(".search-drawer");
  if (!parentDiv) return;

  const searchInput = parentDiv.querySelector(".search-drawer__input");
  const clearBtn = parentDiv.querySelector(".search-drawer__clear");
  const defaultSection = parentDiv.querySelector(".search-product-card__item");

  let productSliderInstance = null;
  let faqSliderInstance = null;
  let relatedSliderInstance = null;
  let productFlkty = null;
  let faqFlkty = null;
  let relatedFlkty = null;
  let debounceTimer;
  let fetchController = null;
  let originalOverflow = "";
  let defaultProducts = null;
  let defaultFaq = null;
  let searchProducts = [];
  let visibleProductCount = 6;
  let isSearchMode = false;

  // ── Typewriter placeholder ──────────────────────────────────
  const fakePH    = parentDiv.querySelector("#fakePlaceholder");
  const typedSpan = fakePH?.querySelector("#typedText");

  const TW = {
    phrases:     ["What are you looking for...", "Search products & FAQs..."],
    typeSpeed:   60,
    deleteSpeed: 35,
    pauseFull:   1800,
    pauseEmpty:  400,
    phraseIdx:   0,
    charIdx:     0,
    deleting:    false,
    running:     false,
    timer:       null,

    tick() {
      if (!this.running || !typedSpan) return;
      const phrase = this.phrases[this.phraseIdx];
      if (!this.deleting) {
        typedSpan.textContent = phrase.slice(0, ++this.charIdx);
        if (this.charIdx === phrase.length) {
          this.deleting = true;
          this.timer = setTimeout(() => this.tick(), this.pauseFull);
          return;
        }
      } else {
        typedSpan.textContent = phrase.slice(0, --this.charIdx);
        if (this.charIdx === 0) {
          this.deleting = false;
          this.phraseIdx = (this.phraseIdx + 1) % this.phrases.length;
          this.timer = setTimeout(() => this.tick(), this.pauseEmpty);
          return;
        }
      }
      this.timer = setTimeout(() => this.tick(), this.deleting ? this.deleteSpeed : this.typeSpeed);
    },

    start() {
      if (!fakePH || !typedSpan) return;
      this.running = true;
      fakePH.style.display = "";
      this.tick();
    },

    stop() {
      this.running = false;
      clearTimeout(this.timer);
      if (fakePH) fakePH.style.display = "none";
    },

    reset() {
      this.stop();
      this.charIdx  = 0;
      this.deleting = false;
      if (typedSpan) typedSpan.textContent = "";
    }
  };
  // ────────────────────────────────────────────────────────────

  function updateClearBtn() {
    if (!clearBtn || !searchInput) return;
    clearBtn.style.display = searchInput.value.length > 0 ? "block" : "none";
  }

  function showDefault() {
    const currentDefaultSection = parentDiv.querySelector(".search-product-card__item.is-slider");
    if (currentDefaultSection) currentDefaultSection.style.display = "";
    updateProductCount(false);
  }

  function destroyFaqSlider() {
    if (faqSliderInstance?.destroy) {
      faqSliderInstance.destroy();
      faqSliderInstance = null;
      faqFlkty = null;
    }
  }

  function destroyRelatedSlider() {
    if (relatedSliderInstance?.destroy) {
      relatedSliderInstance.destroy();
    }

    relatedSliderInstance = null;
    relatedFlkty = null;
  }

  function resetRelatedSearch() {
    const wrapper = parentDiv.querySelector(
      ".search-drawer__related-search"
    );
    const grid = parentDiv.querySelector(
      ".search-related-grid"
    );
    const controls = parentDiv.querySelector(
      ".search-related__bottom-header"
    );

    destroyRelatedSlider();

    if (wrapper) wrapper.style.display = "none";
    if (grid) grid.innerHTML = "";
    if (controls) controls.style.display = "none";
  }

  function destroyProductSlider() {
    if (productSliderInstance?.destroy) {
      productSliderInstance.destroy();
      productSliderInstance = null;
      productFlkty = null;
    }
  }

  function toggleSuggestResults(show) {
    const suggestWrapper = parentDiv.querySelector(".suggest-result-wrapper");
    if (suggestWrapper) suggestWrapper.style.display = show ? "" : "none";
  }

  function toggleFaq(show) {
    const faqWrapper = parentDiv.querySelector(".faq__search");
    if (faqWrapper) faqWrapper.style.display = show ? "" : "none";
  }

  function toggleProductSliderButtons(show) {
    const buttons = parentDiv.querySelector(".search-product-card__buttons-wrap");
    if (buttons) buttons.style.display = show ? "" : "none";
  }

  function filterFaqCards(term) {
    const currentFaq = parentDiv.querySelector(".search-faq__card-block");
    if (!currentFaq || !defaultFaq) return;

    destroyFaqSlider();

    const query = term.trim().toLowerCase();
    const filteredFaq = defaultFaq.cloneNode(true);
    const cards = filteredFaq.querySelectorAll(".search-faq__card-item");

    let matchCount = 0;

    cards.forEach((card) => {
      const searchableText = card.textContent.toLowerCase();
      if (searchableText.includes(query)) {
        matchCount++;
      } else {
        card.remove();
      }
    });

    currentFaq.replaceWith(filteredFaq);

    const faqWrapper = parentDiv.querySelector(".search-faq-wrapper");
    const faqBottom  = parentDiv.querySelector(".search-faq__bottom-header");

    if (faqWrapper) faqWrapper.style.display = matchCount ? "" : "none";
    if (faqBottom)  faqBottom.style.display  = matchCount > 1 ? "" : "none";

    requestAnimationFrame(() => {
      initFaqSlider(parentDiv);
    });
  }

  function restoreFaqCards() {
    const currentFaq = parentDiv.querySelector(".search-faq__card-block");
    if (!currentFaq || !defaultFaq) return;

    destroyFaqSlider();

    currentFaq.replaceWith(defaultFaq.cloneNode(true));

    const faqWrapper = parentDiv.querySelector(".search-faq-wrapper");
    const faqBottom  = parentDiv.querySelector(".search-faq__bottom-header");

    if (faqWrapper) faqWrapper.style.display = "";
    if (faqBottom)  faqBottom.style.display  = "";

    requestAnimationFrame(() => {
      initFaqSlider(parentDiv);
    });
  }

  function clearSearch() {
    if (!searchInput) return;
    toggleProductSliderButtons(true);
    searchInput.value = "";
    updateClearBtn();

    const activeItem = parentDiv.querySelector(".suggest-result__item.active");
    if (activeItem) activeItem.classList.remove("active");

    isSearchMode = false;
    searchProducts = [];
    visibleProductCount = 6;
    parentDiv.querySelector(".search-products-show-more")?.remove();
    
    if (defaultProducts) {
      const currentSlider = parentDiv.querySelector(".search-product-card__item");
      if (currentSlider) {
        currentSlider.replaceWith(defaultProducts.cloneNode(true));
        updateProductCount(false);
        initAjaxForms(parentDiv);
      }
    }
    
    const currentProducts = parentDiv.querySelector(".search-product-card__item");
    if (currentProducts) {
      currentProducts.classList.remove("search-product-grid");
    }
    
    resetRelatedSearch();
    restoreFaqCards();
    showDefault();
    toggleSuggestResults(true);
    toggleFaq(true);
    searchInput.focus();

    // restart typewriter after clear
    TW.reset();
    TW.start();

    requestAnimationFrame(() => {
      initProductSlider(parentDiv);
      initFaqSlider(parentDiv);
    });
  }

  function initAjaxForms(el) {
    if (!window.theme || !theme.AjaxProduct) return;
    el.querySelectorAll('form[action="/cart/add"]').forEach(function (form) {
      form.dataset.ajaxInitialized = "";
      new theme.AjaxProduct(form);
      form.dataset.ajaxInitialized = "true";
    });
  }

  function initProductSlider(scope = parentDiv) {
    if (isSearchMode) return;

    const el = scope.querySelector(".search-product-card__item.is-slider");
    if (!el) return;

    if (productSliderInstance?.destroy) {
      productSliderInstance.destroy();
      productSliderInstance = null;
    }

    productSliderInstance = new theme.Slideshow(el, {
      cellAlign:      "left",
      pageDots:       false,
      contain:        true,
      prevNextButtons: false,
      adaptiveHeight: false,
      wrapAround:     false,
      draggable:      true
    });

    productFlkty = productSliderInstance;
    productFlkty.slideshow.on("change", updateProductBtn);
    updateProductBtn();
  }

  function updateProductCount(showCount = true) {
    const heading     = parentDiv.querySelector(".search-product-card__heding h2");
    const productWrap = parentDiv.querySelector(".search-product-card__item");

    if (!heading) return;

    if (!showCount || !productWrap) {
      heading.textContent = "Best Sellers";
      return;
    }

    if (isSearchMode) {
      heading.textContent = `Products (${searchProducts.length})`;
      return;
    }

    const count =
      productWrap.querySelectorAll(".flickity-slider > *").length ||
      productWrap.children.length;

    heading.textContent = `Products (${count})`;
  }

  function initFaqSlider(scope = parentDiv) {
    const el = scope.querySelector(".search-faq__card-block");
    if (!el) return;
    if (!el.querySelector(".search-faq__card-item")) return;

    if (faqSliderInstance?.destroy) {
      faqSliderInstance.destroy();
      faqSliderInstance = null;
    }

    faqSliderInstance = new theme.Slideshow(el, {
      cellAlign:      "left",
      groupCells:     false,
      pageDots:       false,
      contain:        true,
      prevNextButtons: false,
      adaptiveHeight: false,
      wrapAround:     false,
      draggable:      true
    });

    faqFlkty = faqSliderInstance;
    faqFlkty.slideshow.on("change", updateFaqBtn);
    updateFaqBtn();
  }

  function initRelatedSlider(scope = parentDiv) {
  const el = scope.querySelector(
    ".search-related-grid ul"
  );

  if (!el || !el.querySelector("li")) {
    return;
  }

  destroyRelatedSlider();

  relatedSliderInstance = new theme.Slideshow(el, {
    cellAlign: "left",
    groupCells: false,
    pageDots: false,
    contain: true,
    prevNextButtons: false,
    adaptiveHeight: false,
    wrapAround: false,
    draggable: true
  });

  relatedFlkty = relatedSliderInstance;

  relatedFlkty.slideshow.on(
    "change",
    updateRelatedBtn
  );

  relatedFlkty.slideshow.on(
    "resize",
    updateRelatedBtn
  );

  requestAnimationFrame(() => {
    relatedFlkty?.slideshow?.resize();
    relatedFlkty?.slideshow?.reposition();
    updateRelatedBtn();
  });
}

 function updateRelatedBtn() {
  const controls = parentDiv.querySelector(
    ".search-related__bottom-header"
  );

  if (!relatedFlkty?.slideshow) {
    if (controls) controls.style.display = "none";
    return;
  }

  const progressBar = parentDiv.querySelector(
    ".search-related__slide-bar"
  );

  const prevBtn = parentDiv.querySelector(
    ".search-related__bottom-slide-arrow-prev button"
  );

  const nextBtn = parentDiv.querySelector(
    ".search-related__bottom-slide-arrow-next button"
  );

  const flkty = relatedFlkty.slideshow;
  const currentIndex = flkty.selectedIndex;
  const totalCells = flkty.cells.length;

  if (!totalCells) {
    if (controls) controls.style.display = "none";
    return;
  }

  const sliderWidth = flkty.size.innerWidth;
  const cellWidth = flkty.cells[0]?.size.outerWidth || 1;

  /*
   * Important:
   * Use floor instead of round.
   *
   * The layout displays approximately 2.8 cards.
   * Math.round(2.8) returns 3 and incorrectly hides the controls.
   */
  const visibleCount = Math.max(
    Math.floor(sliderWidth / cellWidth),
    1
  );

  const maxIndex = Math.max(
    totalCells - visibleCount,
    0
  );

  const canScroll = maxIndex > 0;
  const atStart = currentIndex <= 0;
  const atEnd = currentIndex >= maxIndex;

  const thumbWidth = Math.min(
    visibleCount / totalCells,
    1
  );

  const scrollProgress =
    maxIndex > 0
      ? Math.min(currentIndex / maxIndex, 1)
      : 0;

  if (controls) {
    controls.style.display = canScroll ? "flex" : "none";
  }

  if (prevBtn) {
    prevBtn.disabled = atStart;
    prevBtn.style.opacity = atStart ? "0.3" : "1";
    prevBtn.style.pointerEvents = atStart ? "none" : "auto";
  }

  if (nextBtn) {
    nextBtn.disabled = atEnd;
    nextBtn.style.opacity = atEnd ? "0.3" : "1";
    nextBtn.style.pointerEvents = atEnd ? "none" : "auto";
  }

  if (progressBar) {
    progressBar.style.setProperty(
      "--thumb-width",
      thumbWidth
    );

    progressBar.style.setProperty(
      "--progress",
      scrollProgress
    );
  }
}

  function updateProductBtn() {
    if (!productFlkty) return;

    const prevBtn = parentDiv.querySelector(".search-product-card__prev-button");
    const nextBtn = parentDiv.querySelector(".search-product-card__next-button");
    if (!prevBtn || !nextBtn) return;

    const sliderWidth  = productFlkty.slideshow.size.innerWidth;
    const cellWidth    = productFlkty.slideshow.cells[0]?.size.outerWidth || 1;
    const currentIndex = productFlkty.slideshow.selectedIndex;
    const totalSlides  = productFlkty.slideshow.cells.length;
    const slidesPerView = Math.floor(sliderWidth / cellWidth) || 1;

    const atStart = currentIndex === 0;
    const atEnd   = currentIndex >= totalSlides - slidesPerView;

    prevBtn.toggleAttribute("disabled", atStart);
    prevBtn.style.opacity = atStart ? 0.3 : 1;
    nextBtn.toggleAttribute("disabled", atEnd);
    nextBtn.style.opacity = atEnd ? 0.3 : 1;
  }

  function updateFaqBtn() {
    if (!faqFlkty) return;

    const progressBar = parentDiv.querySelector(".search-faq__slide-bar");
    const prevBtn     = parentDiv.querySelector(".search-faq__bottom-slide-arrow-prev button");
    const nextBtn     = parentDiv.querySelector(".search-faq__bottom-slide-arrow-next button");

    const flkty        = faqFlkty.slideshow;
    const currentIndex = flkty.selectedIndex;
    const totalCells   = flkty.cells.length;

    if (!totalCells) return;

    const sliderWidth  = flkty.size.innerWidth;
    const cellWidth    = flkty.cells[0]?.size.outerWidth || 1;
    const visibleCount = Math.max(Math.round(sliderWidth / cellWidth), 1);
    const thumbWidth   = Math.min(visibleCount / totalCells, 1);
    const scrollProgress = currentIndex / Math.max(totalCells - visibleCount, 1);

    const atStart = currentIndex === 0;
    const atEnd   = currentIndex >= totalCells - visibleCount;

    if (prevBtn) prevBtn.style.opacity = atStart ? 0.3 : 1;
    if (nextBtn) nextBtn.style.opacity = atEnd   ? 0.3 : 1;

    if (progressBar) {
      progressBar.style.setProperty("--thumb-width", thumbWidth);
      progressBar.style.setProperty("--progress", scrollProgress);
    }
  }

  function drawerOpen() {
    originalOverflow = document.body.style.overflow;
    parentDiv.classList.add("active");
    document.body.style.overflow = "hidden";

    if (searchInput) searchInput.focus();

    if (!defaultProducts) {
      defaultProducts = parentDiv.querySelector(".search-product-card__item.is-slider")?.cloneNode(true);
    }

    if (!defaultFaq) {
      defaultFaq = parentDiv.querySelector(".search-faq__card-block")?.cloneNode(true);
    }

    initAjaxForms(parentDiv);
    updateClearBtn();
    toggleSuggestResults(true);
    toggleFaq(true);
    updateProductCount(false);

    // start typewriter when drawer opens (only if input is empty)
    if (!searchInput?.value) {
      TW.reset();
      TW.start();
    }

    requestAnimationFrame(() => {
      initProductSlider(parentDiv);
      initFaqSlider(parentDiv);
      initRelatedSlider(parentDiv);
    });
  }

  function drawerClose() {
    parentDiv.classList.remove("active");
    document.body.style.overflow = originalOverflow;
    toggleProductSliderButtons(true);

    // stop typewriter on close
    TW.reset();

    isSearchMode = false;
    searchProducts = [];
    visibleProductCount = 6;
    parentDiv.querySelector(".search-products-show-more")?.remove();

    if (fetchController) {
      fetchController.abort();
      fetchController = null;
    }

    if (productSliderInstance?.destroy) {
      productSliderInstance.destroy();
      productSliderInstance = null;
      productFlkty = null;
    }

    if (faqSliderInstance?.destroy) {
      faqSliderInstance.destroy();
      faqSliderInstance = null;
      faqFlkty = null;
    }

    resetRelatedSearch();

    if (searchInput) {
      searchInput.value = "";
      updateClearBtn();
    }

    const activeItem = parentDiv.querySelector(".suggest-result__item.active");
    if (activeItem) activeItem.classList.remove("active");

    if (defaultProducts) {
      const currentProducts = parentDiv.querySelector(".search-product-card__item");
      if (currentProducts) {
        const freshDefault = defaultProducts.cloneNode(true);
        freshDefault.classList.remove("search-product-grid");
        currentProducts.replaceWith(freshDefault);
      }
    }

    restoreFaqCards();
    toggleSuggestResults(true);
    toggleFaq(true);
    updateProductCount(false);
    initAjaxForms(parentDiv);

    document.dispatchEvent(new CustomEvent("predictive-search:close-all"));
  }

  function showLoading() {
    const loader = parentDiv.querySelector(".search-loading");
    if (loader) loader.style.display = "flex";
  }

  function hideLoading() {
    const loader = parentDiv.querySelector(".search-loading");
    if (loader) loader.style.display = "none";
  }

  function isDrawerOpen() {
    return parentDiv.classList.contains("active");
  }

  function getProductCards(slider) {
    return Array.from(slider.children).filter((child) => {
      return !child.classList.contains("flickity-button") &&
             !child.classList.contains("flickity-page-dots");
    });
  }

  function renderSearchGrid() {
    const productWrap = parentDiv.querySelector(".search-product-card__item");
    if (!productWrap) return;

    toggleProductSliderButtons(false);
    productWrap.classList.add("search-product-grid");
    productWrap.classList.remove("flickity-enabled", "is-draggable");
    productWrap.removeAttribute("tabindex");
    productWrap.innerHTML = "";

    searchProducts.slice(0, visibleProductCount).forEach((card) => {
      productWrap.appendChild(card.cloneNode(true));
    });

    let showMoreBtn = parentDiv.querySelector(".search-products-show-more");

    if (!showMoreBtn) {
      showMoreBtn = document.createElement("button");
      showMoreBtn.type = "button";
      showMoreBtn.className = "search-products-show-more";
      showMoreBtn.textContent = "Show more";
      productWrap.after(showMoreBtn);
    }

    showMoreBtn.style.display =
      visibleProductCount < searchProducts.length ? "block" : "none";

    updateProductCount(true);
    initAjaxForms(parentDiv);
  }


  function renderRelatedSearch(section) {
    const wrapper = parentDiv.querySelector(
      ".search-drawer__related-search"
    );
    const grid = parentDiv.querySelector(
      ".search-related-grid"
    );

    if (!wrapper || !grid) return;

    const articleList = section.querySelector(
      ".search-drawer__related-search ul"
    );

    if (!articleList || !articleList.querySelector("li")) {
      resetRelatedSearch();
      return;
    }

    destroyRelatedSlider();
    grid.innerHTML = "";
    grid.appendChild(articleList.cloneNode(true));
    wrapper.style.display = "block";

    requestAnimationFrame(() => {
      initRelatedSlider(parentDiv);
    });
  }

  function fetchProducts(term) {
    if (!term) return;

    resetRelatedSearch();
    toggleSuggestResults(false);
    toggleFaq(false);

    if (fetchController) fetchController.abort();
    fetchController = new AbortController();

    const loader = parentDiv.querySelector(".search-loading");
    const slider = parentDiv.querySelector(".search-product-card__item.is-slider");

    showLoading();
    if (slider) slider.style.visibility = "hidden";

    const params = new URLSearchParams({
      q: term,
      "resources[type]": "product,collection,query,page,article",
      "resources[limit]": 250,
      "resources[limit_scope]": "each",
      section_id: "search-results"
    });

    fetch(`${window.theme.routes.predictiveSearch}?${params}`, {
      signal: fetchController.signal
    })
      .then((res) => {
        if (!res.ok) throw new Error(res.status);
        return res.text();
      })
      .then((text) => {
        const doc        = new DOMParser().parseFromString(text, "text/html");
        const newSection = doc.querySelector("#shopify-section-search-results");
        if (!newSection) return;

        renderRelatedSearch(newSection);

        const newSlider     = newSection.querySelector(".search-product-card__item.is-slider");
        const currentSlider = parentDiv.querySelector(".search-product-card__item");

        if (newSlider && currentSlider) {
          destroyProductSlider();

          searchProducts      = getProductCards(newSlider);
          visibleProductCount = 6;
          isSearchMode        = true;

          currentSlider.replaceWith(newSlider);
          renderSearchGrid();
        }

        const faqSearch = parentDiv.querySelector(".faq__search");
        if (!faqSearch) {
          filterFaqCards(term);
        }

        requestAnimationFrame(() => {
          initAjaxForms(parentDiv);
          updateProductCount(true);
          hideLoading();
          const updatedSlider = parentDiv.querySelector(".search-product-card__item.is-slider");
          if (updatedSlider) updatedSlider.style.visibility = "";
        });
      })
      .catch((err) => {
        hideLoading();
        const updatedSlider = parentDiv.querySelector(".search-product-card__item.is-slider");
        if (updatedSlider) updatedSlider.style.visibility = "";
        if (err.name !== "AbortError") console.error(err);
      });
  }

  document.addEventListener("click", function (e) {
    if (e.target.closest(".icon-search_drawer")) {
      drawerOpen();
      return;
    }

    const showMoreBtn = e.target.closest(".search-products-show-more");

    if (showMoreBtn) {
      if (showMoreBtn.classList.contains("is-loading")) return;

      showMoreBtn.classList.add("is-loading");
      showMoreBtn.disabled = true;
      showMoreBtn.innerHTML = `<span class="show-more-spinner"></span> Loading`;

      setTimeout(() => {
        visibleProductCount += 6;
        renderSearchGrid();

        const updatedBtn = parentDiv.querySelector(".search-products-show-more");
        if (updatedBtn) {
          updatedBtn.classList.remove("is-loading");
          updatedBtn.disabled = false;
          updatedBtn.textContent = "Show more";
        }
      }, 800);

      return;
    }

    if (!isDrawerOpen()) return;

    if (e.target.closest(".search-drawer__clear")) {
      clearSearch();
      return;
    }

    if (e.target.closest(".search-product-card__prev-button")) {
      productFlkty?.slideshow.previous();
      updateProductBtn();
      return;
    }

    if (e.target.closest(".search-product-card__next-button")) {
      productFlkty?.slideshow.next();
      updateProductBtn();
      return;
    }

    if (e.target.closest(".search-related__bottom-slide-arrow-prev")) {
      relatedFlkty?.slideshow.previous();
      updateRelatedBtn();
      return;
    }

    if (e.target.closest(".search-related__bottom-slide-arrow-next")) {
      relatedFlkty?.slideshow.next();
      updateRelatedBtn();
      return;
    }

    if (e.target.closest(".search-faq__bottom-slide-arrow-prev")) {
      faqFlkty?.slideshow.previous();
      updateFaqBtn();
      return;
    }

    if (e.target.closest(".search-faq__bottom-slide-arrow-next")) {
      faqFlkty?.slideshow.next();
      updateFaqBtn();
      return;
    }

    const suggestItem = e.target.closest(".suggest-result__item");
    if (suggestItem) {
      const activeItem = parentDiv.querySelector(".suggest-result__item.active");
      if (activeItem) activeItem.classList.remove("active");

      suggestItem.classList.add("active");

      const searchTerm = suggestItem.dataset.search;

      if (searchInput && searchTerm) {
        searchInput.value = searchTerm;
        searchInput.focus();
        updateClearBtn();
        TW.stop(); // hide typewriter when suggestion is clicked
      }

      fetchProducts(searchTerm);
      return;
    }

    if (e.target.closest(".search-drawer__submit")) {
      e.preventDefault();

      const term = searchInput?.value.trim();
      if (!term) return;

      window.location.href = `${window.Shopify?.routes?.root || "/"}search?q=${encodeURIComponent(term)}&options[prefix]=last&type=product`;
      return;
    }

    if (e.target.closest(".search_drawer_back_icon")) {
      drawerClose();
      return;
    }

    if (e.target.closest(".search-drawer__cancel")) {
      clearSearch();
      return;
    }

    if (e.target.closest("form[action='/cart/add']")) {
      setTimeout(() => {
        drawerClose();
      }, 500);
    }

    if (!e.target.closest(".search-drawer")) {
      drawerClose();
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && isDrawerOpen()) {
      drawerClose();
    }
  });

  searchInput?.addEventListener("input", function () {
    const value = this.value.trim();

    updateClearBtn();

    // show/hide typewriter based on input value
    if (this.value.length > 0) {
      TW.stop();
    } else {
      TW.reset();
      TW.start();
    }

    clearTimeout(debounceTimer);

    if (!value.length) {
      isSearchMode = false;
      searchProducts = [];
      visibleProductCount = 6;
      parentDiv.querySelector(".search-products-show-more")?.remove();
      toggleProductSliderButtons(true);
      resetRelatedSearch();

      if (defaultProducts) {
        const currentSlider = parentDiv.querySelector(".search-product-card__item");
        if (currentSlider) {
          currentSlider.replaceWith(defaultProducts.cloneNode(true));
        }
      }

      showDefault();
      restoreFaqCards();
      toggleSuggestResults(true);
      toggleFaq(true);

      requestAnimationFrame(() => {
        initProductSlider(parentDiv);
        initFaqSlider(parentDiv);
        updateProductCount(false);
      });

      return;
    }

    debounceTimer = setTimeout(() => {
      fetchProducts(value);
    }, 300);
  });

  document.addEventListener("theme:section:reinit", () => {
    if (isDrawerOpen()) {
      initProductSlider(parentDiv);
      initFaqSlider(parentDiv);
      initRelatedSlider(parentDiv);
    }
  });

  document.addEventListener("predictive-search:close-all", () => {
    if (isDrawerOpen()) {
      initProductSlider(parentDiv);
      initFaqSlider(parentDiv);
      initRelatedSlider(parentDiv);
    }
  });
});

document.addEventListener("submit", async function (event) {
  const form = event.target;

  if (!form.matches('.search-product-card__item form[action="/cart/add"]')) return;

  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  const button = form.querySelector('[type="submit"], [name="add"]');
  const originalButtonHTML = button ? button.innerHTML : "";

  if (button) {
    button.disabled = true;
    button.classList.add("is-loading");
    button.innerHTML = `<span class="cart-add-spinner"></span>`;
  }

  try {
    const formData = new FormData(form);

    const response = await fetch("/cart/add.js", {
      method: "POST",
      body: formData,
      headers: { Accept: "application/json" }
    });

    if (!response.ok) throw await response.json();

    const product = await response.json();

    document.dispatchEvent(new CustomEvent("cart:open"));
    document.dispatchEvent(new CustomEvent("ajaxProduct:added", { detail: { product } }));

  } catch (error) {
    console.error("Quick add failed:", error);
  } finally {
    if (button) {
      button.disabled = false;
      button.classList.remove("is-loading");
      button.innerHTML = originalButtonHTML;
    }
  }
}, true);

class ShippingBar extends HTMLElement {

  constructor() {
    super();

    this.threshold = Number(this.dataset.threshold) * 100;

    this.text = this.querySelector(
      '.drawer__shippping-bar-text p'
    );

    this.progress = this.querySelector(
      '.drawer__shippping-bar'
    );

    this.update = this.update.bind(this);
  }


  connectedCallback() {

    this.update();

    [
    'cart:updated',
    'cart:change',
    'ajaxProduct:added'
  ].forEach(event => {
    document.addEventListener(
      event,
      this.update
    );
  });

  }

formatMoney(cents) {

  return Shopify?.money_format
    ? Shopify.formatMoney(cents, Shopify.money_format)
    : `$${(cents / 100).toFixed(2)}`;

}
  async update() {

    try {

      const cart = await fetch('/cart.js')
        .then(res => res.json());


      const cartTotal = cart.total_price;


      const progress = Math.min(
        (cartTotal / this.threshold) * 100,
        100
      );

      if (this.progress) {

        this.progress.style.setProperty(
          '--bar-width',
          `${progress}%`
        );

      }


      if (this.text) {

        if (cartTotal >= this.threshold) {

          this.text.textContent =
            "✓ You've unlocked";

        } else {

          const remaining =
            this.threshold - cartTotal;


          this.text.textContent =
            `You're ${this.formatMoney(remaining)}
            away from Free Shipping`;

        }

      }


    } catch(error) {

      console.error(error);

    }

  }


  disconnectedCallback() {

    [
    'cart:updated',
    'cart:change',
    'ajaxProduct:added'
  ].forEach(event => {
    document.removeEventListener(
      event,
      this.update
    );
  });

  }

}


customElements.define(
  'shipping-bar',
  ShippingBar
);